"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BreadcrumbsRef", {
  enumerable: true,
  get: function get() {
    return _types.BreadcrumbsRef;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _ChevronRight = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronRight"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Link = _interopRequireDefault(require("../Link"));

var _Typography = require("../Typography");

var _propTypes2 = require("./propTypes");

var _types = require("./types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var BreadcrumbsOl = (0, _styledComponents.default)(_Flex.default).attrs({
  as: 'ol',
  alignItems: 'center'
}).withConfig({
  displayName: "Breadcrumbs__BreadcrumbsOl",
  componentId: "sc-16xe9n1-0"
})(["margin:0;padding:0;"]);
var BreadcrumbsLi = (0, _styledComponents.default)(_Flex.default).attrs({
  as: 'li',
  alignItems: 'center'
}).withConfig({
  displayName: "Breadcrumbs__BreadcrumbsLi",
  componentId: "sc-16xe9n1-1"
})([""]);
var BreadcrumbSeparator = (0, _styledComponents.default)(_ChevronRight.default).withConfig({
  displayName: "Breadcrumbs__BreadcrumbSeparator",
  componentId: "sc-16xe9n1-2"
})(["color:", ";margin-left:", "px;margin-right:", "px;"], (0, _toColorString.default)(_color.default.visualInterest.licoriceMousse.medium), _spacing.default.base * 0.5, _spacing.default.base * 0.5);
var BreadcrumbCurrent = (0, _styledComponents.default)(_Typography.P).attrs({
  as: 'span',
  size: 'small',
  weight: 'medium'
}).withConfig({
  displayName: "Breadcrumbs__BreadcrumbCurrent",
  componentId: "sc-16xe9n1-3"
})(["color:", ";"], (0, _toColorString.default)(_color.default.base.alaskanHusky));

var Breadcrumbs = function Breadcrumbs(_ref, ref) {
  var ariaLabel = _ref['aria-label'],
      current = _ref.current,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? [] : _ref$path,
      rest = _objectWithoutProperties(_ref, ["aria-label", "current", "path"]);

  var translate = (0, _useTranslations.default)();
  return _react.default.createElement("nav", _extends({
    "aria-label": translate(ariaLabel, 'breadcrumbs.aria.label')
  }, rest, {
    ref: ref
  }), _react.default.createElement(BreadcrumbsOl, null, path.map(function (_ref2) {
    var icon = _ref2.icon,
        iconPosition = _ref2.iconPosition,
        size = _ref2.size,
        variant = _ref2.variant,
        linkProps = _objectWithoutProperties(_ref2, ["icon", "iconPosition", "size", "variant"]);

    return _react.default.createElement(BreadcrumbsLi, {
      key: linkProps.to
    }, _react.default.createElement(_Link.default, _extends({
      size: "small"
    }, linkProps)), _react.default.createElement(BreadcrumbSeparator, {
      size: "small"
    }));
  }), _react.default.createElement(BreadcrumbsLi, null, _react.default.createElement(BreadcrumbCurrent, null, current))));
};

var BreadcrumbsWithRef = (0, _react.forwardRef)(Breadcrumbs); // @ts-ignore

BreadcrumbsWithRef.propTypes = {
  current: _propTypes.default.string.isRequired,
  path: _propTypes2.pathValidator.isRequired
};
BreadcrumbsWithRef.displayName = 'Breadcrumbs';
var _default = BreadcrumbsWithRef;
exports.default = _default;